import { ROUTES } from '@/routes/paths';

const SIGNIN_REDIRECT_URL = `${ROUTES.signin}?ctab=init`;
const LEGACY_SIGNIN_PATH = '/signIn';

let isUnauthorizedRedirecting = false;

export const handleUnauthorizedStatus = (status?: number) => {
  if (status !== 401) {
    return false;
  }

  if (typeof window === 'undefined') {
    return true;
  }

  localStorage.removeItem('cplatToken');

  if (isUnauthorizedRedirecting) {
    return true;
  }

  const { pathname, search } = window.location;
  const isSigninPage =
    pathname.startsWith(ROUTES.signin) || pathname.startsWith(LEGACY_SIGNIN_PATH);
  const isAlreadyRedirectedSignin = pathname.startsWith(ROUTES.signin) && search.includes('ctab=');

  if (isSigninPage || isAlreadyRedirectedSignin) {
    return true;
  }

  isUnauthorizedRedirecting = true;
  window.location.replace(SIGNIN_REDIRECT_URL);
  return true;
};
